import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AutoEnterpriseService {

  constructor(
    public apiService: ApiService
  ) { }

  fetch(data: any): Promise<any> {
    return this.apiService.fetch('/common/auto-complete/sign/enterprise', data);
  }

  fetchAuto(keyword: string) {
    const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/enterprise?filter=${encodeURIComponent(keyword)}`);
    return res;
  }

  searchUser(keyword: string) {
    const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/user?filter=${encodeURIComponent(keyword)}`);
    return res;
  }

  searchUserOrDepartment(keyword: string) {
    const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/contract-share/user-department?filter=${encodeURIComponent(keyword)}`);
    return res;
  }

}
